import { render } from "./serviceCategoryBannerComponent.vue?vue&type=template&id=250e8125&scoped=true"
import script from "./serviceCategoryBannerComponent.vue?vue&type=script&lang=js"
export * from "./serviceCategoryBannerComponent.vue?vue&type=script&lang=js"

import "./serviceCategoryBannerComponent.vue?vue&type=style&index=0&id=250e8125&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250e8125"]])

export default __exports__